const PublicCertifications = () =>
  import(
    /* webpackChunkName: "PublicSession" */ "@/components/certipers-public/PublicCertifications.vue"
  );

const Register = () =>
  import(/* webpackChunkName: "Register" */ "@/components/certipers-public/Register.vue");

export default [
  {
    path: "",
    name: "publicCertifications",
    component: PublicCertifications,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "register",
    name: "publicRegister",
    component: Register,
    meta: {
      isPublic: true,
    },
  },
];
